import { useTranslation } from "react-i18next";
import { DataGrid, GridColDef, GridValidRowModel } from "@mui/x-data-grid";

export type { GridColDef };

interface TableViewProps<R extends GridValidRowModel> {
  rows: R[];
  columns: GridColDef<R>[];
  getRowId?: (row: R) => string;
  noRowsMessage?: string;
  tableViewType?: string;
}

const TableView = <R extends GridValidRowModel>({
  rows,
  columns,
  getRowId,
  noRowsMessage,
  tableViewType,
}: TableViewProps<R>) => {
  const { t } = useTranslation();

  return (
    <div data-testid={tableViewType ? `${tableViewType}-table-view` : undefined}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId}
        autoHeight
        hideFooter
        disableRowSelectionOnClick
        localeText={{ noRowsLabel: noRowsMessage ?? t("No results") }}
        sx={{ borderTop: "none", borderLeft: "none", borderRight: "none" }}
      />
    </div>
  );
};

export default TableView;
